import React, { useState, useEffect } from 'react'
import Navbar from './Navbar'
import './style/dest.css'
import dt from "../data.json"



export const Heading = (props) => {
  return (
    <span className='heading'>

      <span className="num">
        {props.num}
      </span>
      <span className="title">
        {props.title}
      </span>
    </span>)
}

const Destination = () => {
  const [option,setOption]=useState("Moon");
  const [content,setContent]=useState(dt.destinations[0])
  const [Bgimg, setBgimg] = useState(`url("./assets/destination/background-destination-desktop.jpg")`);
  useEffect(() => {
    if (window.innerWidth <= 768 && window.innerWidth > 450) {
      setBgimg(`url("./assets/destination/background-destination-tablet.jpg")`)
    } else if (window.innerWidth <= 660) {
      setBgimg(`url("./assets/destination/background-destination-mobile.jpg")`)
    }
  }, [Bgimg])


  const change=(e)=>{
setOption(dt.destinations[e].name);
setContent(dt.destinations[e]);
  }

  return (
    <>
      <section className='dest' style={{ background: `${Bgimg}` }}>

        <Navbar/>

        <div className="dest-cont">
          <Heading num={"01"} title={"Pick Your Destination"} />
          <div className="content">
            <div className="subMenu">
              <span onClick={()=>change(0)} className={option==="Moon"?"activee":""}>Moon</span>
              <span onClick={()=>change(1)} className={option==="Mars"?"activee":""}>Mars</span>
              <span onClick={()=>change(2)} className={option==="Europa"?"activee":""}>Europa</span>
              <span onClick={()=>change(3)} className={option==="Titan"?"activee":""}>Titan</span>
            </div>
<div className="insideContent">
<img src={`./assets/destination/image-${option}.webp`} alt="" />
<div className="info">

  <h1>{content.name}</h1>
  <p> {content.description}</p>
  <hr />
  <div className="dist-box">
    <span >
<h2>AVG. DISTANCE</h2>
<p className='avg'>{content.distance}</p>
    </span>
    <span>
      <h2>Est. travel time</h2>
      <p className='avg'>{content.travel}</p>
    </span>
  </div>
</div>

</div>
        </div>

        </div>
       
      </section>


    </>

  )
}

export default Destination